var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70778 0H1.45778C0.654445 0 0 0.654444 0 1.45778V5.20778C0 6.01222 0.654445 6.66667 1.45778 6.66667H7.70778C8.51222 6.66667 9.16667 6.01222 9.16667 5.20778V1.45778C9.16667 0.654444 8.51222 0 7.70778 0Z",
    fill: "#8E99A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70778 8.3335H1.45778C0.654445 8.3335 0 8.98794 0 9.79238V18.5424C0 19.3457 0.654445 20.0002 1.45778 20.0002H7.70778C8.51222 20.0002 9.16667 19.3457 9.16667 18.5424V9.79238C9.16667 8.98794 8.51222 8.3335 7.70778 8.3335Z",
    fill: "#8E99A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5424 13.3335H12.2924C11.4879 13.3335 10.8335 13.9879 10.8335 14.7924V18.5424C10.8335 19.3468 11.4879 20.0002 12.2924 20.0002H18.5424C19.3457 20.0002 20.0002 19.3457 20.0002 18.5424V14.7924C20.0002 13.9879 19.3457 13.3335 18.5424 13.3335Z",
    fill: "#8E99A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5424 0H12.2924C11.4879 0 10.8335 0.654445 10.8335 1.45778V10.2078C10.8335 11.0122 11.4879 11.6667 12.2924 11.6667H18.5424C19.3457 11.6667 20.0002 11.0122 20.0002 10.2078V1.45778C20.0002 0.654445 19.3457 0 18.5424 0Z",
    fill: "#8E99A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.f770f47b48c88b27e69412131a67b892.svg";
export { ForwardRef as ReactComponent };